/** @format */

// /** @format */

import { FACTS_FIELD_KEYS } from '../utilities';
import { getAssociationData } from './association';
import { getParticipationAndRepairFundData } from './participationAndRepairFund';
import { getAreaData } from './propertyTypeAndAreas';
import { getOperationsData } from './operations';
import { getPlotData } from './plot';
import { getInteriorData } from './interior';
import { getEnvironmentData } from './environment';
import { getBuildingData } from './building';
import { getFloorElevatorData } from './floorAndElevator';
import { getExteriorData } from './exterior';
import { getDistancesData } from './distances';
import { getChargeData } from './charge';
import { getCompilationOfAreasData } from './compilationOfAreas';
import { getInsuranceData } from './insurance';
import { getElectricityData } from './electricity';
import { getEnrollmentsData } from './enrollments';

export default {
  facts: {
    [FACTS_FIELD_KEYS.ASSOCIATION]: {
      getData: getAssociationData
    },
    [FACTS_FIELD_KEYS.PARTICIPATION_REPAIR_FUND]: {
      getData: getParticipationAndRepairFundData
    },
    [FACTS_FIELD_KEYS.AREA]: {
      getData: getAreaData
    },
    [FACTS_FIELD_KEYS.OPERATIONS]: {
      getData: getOperationsData
    },
    [FACTS_FIELD_KEYS.PLOT]: {
      getData: getPlotData
    },
    [FACTS_FIELD_KEYS.INTERIOR]: {
      getData: getInteriorData
    },
    [FACTS_FIELD_KEYS.ENVIRONMENT]: {
      getData: getEnvironmentData
    },
    [FACTS_FIELD_KEYS.BUILDING]: {
      getData: getBuildingData
    },
    [FACTS_FIELD_KEYS.FLOOR_AND_ELEVATOR]: {
      getData: getFloorElevatorData
    },
    [FACTS_FIELD_KEYS.EXTERIOR]: {
      getData: getExteriorData
    },
    [FACTS_FIELD_KEYS.DISTANCES]: {
      getData: getDistancesData
    },
    [FACTS_FIELD_KEYS.CHARGE]: {
      getData: getChargeData
    },
    [FACTS_FIELD_KEYS.COMPILATION_OF_AREAS]: {
      getData: getCompilationOfAreasData
    },
    [FACTS_FIELD_KEYS.INSURANCE]: {
      getData: getInsuranceData
    },
    [FACTS_FIELD_KEYS.ELECTRICITY]: {
      getData: getElectricityData
    },
    [FACTS_FIELD_KEYS.ENROLLMENTS]: {
      getData: getEnrollmentsData
    }
  },
  factsComponents: [
    FACTS_FIELD_KEYS.AREA,
    FACTS_FIELD_KEYS.OPERATIONS,
    FACTS_FIELD_KEYS.PLOT,
    FACTS_FIELD_KEYS.INTERIOR,
    FACTS_FIELD_KEYS.ENVIRONMENT,
    FACTS_FIELD_KEYS.BUILDING,
    FACTS_FIELD_KEYS.FLOOR_AND_ELEVATOR,
    FACTS_FIELD_KEYS.EXTERIOR,
    FACTS_FIELD_KEYS.DISTANCES,
    FACTS_FIELD_KEYS.CHARGE,
    FACTS_FIELD_KEYS.COMPILATION_OF_AREAS,
    FACTS_FIELD_KEYS.INSURANCE,
    FACTS_FIELD_KEYS.ELECTRICITY,
    FACTS_FIELD_KEYS.ENROLLMENTS
  ]
};
